module.exports = __webpack_public_path__ + "static/media/sample_survey5.6c715ce3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/sample_survey5.csv
// module id = 969
// module chunks = 0